import type { OptionsVisibility } from '@atlassian/ui-modifications-core/types/options-visibility';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';

export interface PriorityOption {
	value: string;
	label: string;
	selected: boolean;
	children: PriorityOption[];
}

export const validatePrioritySetValue = (value: string): boolean => isNotEmptyString(value);

export const prioritySetValueTransformer = (optionId: string, options: PriorityOption[]) => {
	const option = options?.find((item) => item.value === optionId);
	return option;
};

export const prioritySetOptionsVisibility = (
	{ options, isVisible }: OptionsVisibility,
	lookupValues?: PriorityOption[],
) => {
	return lookupValues?.filter(({ value }) =>
		isVisible ? options.includes(value) : !options.includes(value),
	);
};

export interface PriorityPublicGetValue {
	id: string;
	name: string;
}

export const priorityGetValueTransformer = (
	data: PriorityOption | null | undefined,
): PriorityPublicGetValue | null => {
	if (!data) {
		return null;
	}

	return {
		id: data.value,
		name: data.label,
	};
};

export const modifyPriorityValueToBasic = (data: PriorityOption) => data?.value;
